export default "__VITE_ASSET__PO2pUe4U__"